
import React from 'react';

export const FlameGraphic: React.FC = () => {
  return (
    <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 pointer-events-none opacity-40 z-[-1]">
      <div className="relative h-96 w-96">
        {/* Main flame */}
        <div className="absolute bottom-0 left-1/2 transform -translate-x-1/2 w-32 h-48 bg-gradient-to-t from-orange-500 via-orange-400 to-yellow-300 rounded-t-full animate-flame-flicker" />
        
        {/* Center flame */}
        <div className="absolute bottom-10 left-1/2 transform -translate-x-1/2 w-24 h-40 bg-gradient-to-t from-orange-400 via-yellow-300 to-white rounded-t-full animate-flame-flicker animation-delay-200" />
        
        {/* Inner flame */}
        <div className="absolute bottom-16 left-1/2 transform -translate-x-1/2 w-16 h-32 bg-gradient-to-t from-yellow-300 via-yellow-200 to-white rounded-t-full animate-flame-flicker animation-delay-300" />
        
        {/* Small flame particles */}
        <div className="absolute bottom-48 left-1/2 transform -translate-x-1/2 translate-x-12 w-4 h-8 bg-gradient-to-t from-orange-400 to-yellow-300 rounded-full animate-flame-flicker animation-delay-150" />
        <div className="absolute bottom-56 left-1/2 transform -translate-x-1/2 -translate-x-10 w-3 h-6 bg-gradient-to-t from-orange-400 to-yellow-200 rounded-full animate-flame-flicker animation-delay-300" />
        
        {/* Additional animated particles */}
        <div className="absolute bottom-64 left-1/2 transform -translate-x-1/2 translate-x-16 w-3 h-6 bg-gradient-to-t from-orange-500 to-yellow-300 rounded-full animate-flame-flicker animation-delay-400" />
        <div className="absolute bottom-72 left-1/2 transform -translate-x-1/2 -translate-x-14 w-2 h-4 bg-gradient-to-t from-orange-500 to-yellow-200 rounded-full animate-flame-flicker animation-delay-500" />
      </div>
      
      {/* Glow effect */}
      <div className="absolute bottom-0 left-1/2 transform -translate-x-1/2 -bottom-10 w-64 h-64 rounded-full bg-orange-500/20 blur-xl" />
    </div>
  );
};
